<template>
  <Modal
    as-form
    open
    persistent
    :size="ModalSize.LG"
    :title="$t('accept-terms-modal.title')"
  >
    <template #body>
      <p class="font-semibold text-on-surface text-center mt-9">
        <i18n-t keypath="accept-terms-modal.description">
          <template #title> {{ props.hub.title }} </template>
        </i18n-t>
      </p>
      <div
        class="bg-disabled p-8 flex items-center justify-between flex-wrap mt-6 rounded-2xl"
        :class="{ 'border border-error': showTermsNotViewedError }"
      >
        <span class="font-semibold max-w-100 text-on-surface text-lg">
          {{ props.hub.termsDescription }}
        </span>
        <Btn
          :color="BtnColor.PRIMARY"
          :variant="BtnVariant.OUTLINED"
          :size="BtnSize.LG"
          :to="props.hub.termsUrl"
          target="_blank"
          @click="onViewTerms"
        >
          View
        </Btn>
      </div>
      <p
        class="text-on-surface text-sm text-center mt-3 mb-8"
        :class="{ 'text-error': showTermsNotViewedError }"
      >
        {{ $t('accept-terms-modal.requirement') }}
      </p>
    </template>

    <template #actions="{ closeModal }">
      <div class="flex justify-between py-5 px-4 sm:px-12 border-t">
        <Btn :size="BtnSize.LG" to="/">
          {{ $t('accept-terms-modal.decline') }}
        </Btn>
        <Btn
          :color="BtnColor.PRIMARY"
          :variant="BtnVariant.FILLED"
          :size="BtnSize.LG"
          @click="onAcceptTerms(closeModal)"
        >
          {{ $t('accept-terms-modal.accept') }}
        </Btn>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import { ref } from '#imports';
import { useAcceptedHubsTerms } from '~/pages/_components/hub-details/_composables/use-accepted-hubs-terms';
import { Modal, ModalSize } from '~/components/modals/modal';

type Props = {
  hub: Record<string, unknown>;
};
const props = defineProps<Props>();
const { acceptHubTerms } = useAcceptedHubsTerms();

const termsViewed = ref<boolean>(false);
const showTermsNotViewedError = ref<boolean>(false);

const onViewTerms = () => {
  termsViewed.value = true;
  showTermsNotViewedError.value = false;
};

const onAcceptTerms = (closeModal: () => void) => {
  if (!termsViewed.value) {
    showTermsNotViewedError.value = true;
    return;
  }
  acceptHubTerms(props.hub.id);

  closeModal();
};
</script>
